var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ds-card ds-stat-card" }, [
    _c("div", { staticClass: "ds-stat-card__top" }, [
      _c(
        "div",
        { staticClass: "ds-icon-tile", style: { background: _vm.toneColor } },
        [_c("ds-icon", { attrs: { name: _vm.icon, size: 34 } })],
        1
      ),
      _c("div", { staticClass: "ds-stat-card__value-wrap" }, [
        _c("div", { staticClass: "ds-stat-card__label" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
        _c("div", { staticClass: "ds-stat-card__value" }, [
          _vm._v(_vm._s(_vm.value)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "ds-stat-card__bottom" }, [
      _c("div", { staticClass: "ds-card-divider" }),
      _c("div", { staticClass: "ds-card-footer" }, [
        _c("span", [_vm._t("caption")], 2),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }